// Direct backend server on :5001

const API_BASE = process.env.REACT_APP_API_SELFCARE_URL as string;

// const API_BASE = 'http://localhost:5000/api';

export async function fetchReports(start:any, end:any, userId:any, msisdn:any, verificationStatus:any, page:number, pageSize:number) {
    const params = new URLSearchParams();
    if (start) params.append('startDate', start);
    if (end) params.append('endDate', end);
    if (userId) params.append('userId', userId);
    if (msisdn) params.append('msisdn', msisdn);
    if (verificationStatus) params.append('verificationStatus', verificationStatus);
    params.append('page', String(page));
    params.append('pageSize', String(pageSize));

    const url = `${API_BASE}/admin-ops/subscribers?${params.toString()}`;
    // debug
    // eslint-disable-next-line no-console
    console.log('Fetching reports from', url);
    const res = await fetch(url);
    if (!res.ok) throw new Error('Failed to fetch reports');
    return res.json();
}

export async function fetchVerificationStates() {
    const res = await fetch(`${API_BASE}/admin-ops/verification-states`);
    if (!res.ok) return [];
    return res.json();
}

export async function exportReport(type:string, filters: any) {
    const params = new URLSearchParams();
    if (filters.startDate) params.append('startDate', filters.startDate);
    if (filters.endDate) params.append('endDate', filters.endDate);
    if (filters.userId) params.append('userId', filters.userId);
    if (filters.msisdn) params.append('msisdn', filters.msisdn);
    if (filters.verificationStatus) params.append('verificationStatus', filters.verificationStatus);
    const url = `${API_BASE}/admin-ops/export/${type}?${params.toString()}`;
    return url;
}



